import React from "react";
import { Herom, TredningPostsm, TeamInfo, FaqSection, Footer, CommunityStats } from "../components";
import { useSelector } from "react-redux";
import ProfileAlert from "../components/ProfileAlert"; 

function HomePage() {
  const { user } = useSelector((state) => state.user);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="relative overflow-hidden pt-16 pb-12 sm:pt-24 sm:pb-20">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-50 via-transparent to-transparent -z-10 opacity-70" />

        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wide text-blue-600 uppercase bg-blue-50 rounded-full">
            By students, For students
          </div>

          <h1 className="text-5xl sm:text-8xl font-black tracking-tight text-slate-900 leading-[1.1] mb-6">
            Welcome to <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-700 to-indigo-600">CampusIRA</span>
          </h1>

          <p className="max-w-2xl mx-auto text-lg sm:text-xl text-gray-500 font-medium leading-relaxed mb-10">
            Discover and share interview experiences. Join our community to connect, learn, and grow with peers across campuses.
          </p>

          {user && !user.branch && !user.graduationYear && <ProfileAlert />}
        </div>
      </div>
      {/* --- MAIN CONTENT SECTIONS --- */}
      <div className="space-y-10">
        <section className="bg-white">
           <Herom />
        </section>

        {/* Community Stats (The one we made earlier) */}
    

        <section className="bg-gray-50 py-16">
          <TredningPostsm />
        </section>
        
         <CommunityStats />

        <div className="max-w-4xl mx-auto px-6 py-20">
            <FaqSection />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default HomePage;